import VuexPersistence from 'vuex-persist';
import { assocPath, path, pipe } from 'ramda';

const SELECTED_FACTORS_PATH = ['jobEvaluation', 'supplies', 'valuationModel', 'selectedFactors'];
const SELECTED_FACTOR = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'selectedFactor'];
const SELECTED_FACTOR_DEGREE = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'selectedFactor'];
const FACTOR_DEGREES = ['jobEvaluation', 'supplies', 'valuationModel', 'degree', 'factorDegrees'];
const COMBINATIONS = ['jobEvaluation', 'supplies', 'valuationModel', 'weighing', 'combinations'];

const storeReducer = state => pipe(
	assocPath(SELECTED_FACTORS_PATH, path(SELECTED_FACTORS_PATH, state)),
	assocPath(SELECTED_FACTOR, path(SELECTED_FACTOR, state)),
	assocPath(COMBINATIONS, path(COMBINATIONS, state)),
	assocPath(SELECTED_FACTOR_DEGREE, path(SELECTED_FACTOR_DEGREE, state)),
	assocPath(FACTOR_DEGREES, path(FACTOR_DEGREES, state)),
)({});

export default new VuexPersistence({
	key: 'praktiko:store',
	storage: window.localStorage,
	reducer: storeReducer,
});



// WEBPACK FOOTER //
// ./src/store/persist.js